<template>
  <div id="app">
    <router-view />
  </div>
</template>


<script>
export default {
  data() {
    return {}
  },
  watch: {
    '$route'(to, from) { // 监听路由变化
      this.$store.commit("premissions/FOR_ROUTER", to);
    }
  }
}
</script>

<style lang="less">
@import url('@/assets/css/resel.less');

body {
  background: #F6F7FA;

}
</style>
